import { Component, Input, Output, EventEmitter, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';

export interface EntityAction {
  label: string;
  icon?: string;
  action: () => void;
  disabled?: boolean;
  color?: 'primary' | 'accent' | 'warn';
}

export interface EntityTab {
  label: string;
  index: number;
  icon?: string;
}

@Component({
  selector: 'app-entity-actions-sidenav',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule
  ],
  templateUrl: './entity-actions-sidenav.component.html',
  styleUrls: ['./entity-actions-sidenav.component.css']
})
export class EntityActionsSidenavComponent {
  /**
   * Title to display at the top of the sidenav (e.g., "Contract Actions", "Party Actions")
   */
  @Input() title = 'Actions';

  /**
   * List of actions to display (Edit, Add Attachment, etc.)
   */
  @Input() actions = signal<EntityAction[]>([]);

  /**
   * List of tabs for navigation
   */
  @Input() tabs = signal<EntityTab[]>([]);

  /**
   * Whether to show the navigation section
   */
  @Input() showNavigation = true;

  /**
   * Current selected tab index
   */
  @Input() selectedTabIndex = 0;

  /**
   * Emit when a tab is selected
   */
  @Output() tabSelected = new EventEmitter<number>();

  /**
   * Handle tab selection
   */
  onTabClick(index: number): void {
    this.tabSelected.emit(index);
  }

  /**
   * Execute an action
   */
  executeAction(action: EntityAction): void {
    if (!action.disabled) {
      action.action();
    }
  }
}
